module.exports = __webpack_public_path__ + "img/SKMJ_etc10.aeaf1e9b.jpg";